import React from "react";

const PrivacyPage = () => {
  return (
    <div className="legal-page">
      <div className="article-container">
        <header className="article-header">
          <p className="section-label">Legal</p>
          <h1>Privacy Policy</h1>
          <div className="article-meta">
            <span>Effective Date: January 1, 2025</span>
          </div>
        </header>

        <div className="article-body">
          <h2>1. Information We Collect</h2>
          <p>
            When you use our website or contact us, we may collect the following
            information:
          </p>
          <ul>
            <li>
              <strong>Contact form data:</strong> Name, email address, company
              name, and message content submitted through our contact form.
            </li>
            <li>
              <strong>Usage data:</strong> Basic analytics information such as
              pages visited and time spent on the site, collected through
              standard web technologies.
            </li>
          </ul>
          <p>
            We do not collect sensitive personal information, financial data, or
            any information beyond what you voluntarily provide.
          </p>

          <h2>2. How We Use Your Information</h2>
          <p>We use the information we collect for the following purposes:</p>
          <ul>
            <li>To respond to your inquiries submitted through our contact form</li>
            <li>To communicate with you about potential projects or services</li>
            <li>To improve our website and services</li>
          </ul>
          <p>
            We do not sell, rent, or trade your personal information to third
            parties.
          </p>

          <h2>3. Third-Party Services</h2>
          <p>
            Our contact form uses EmailJS, a third-party email delivery service,
            to process form submissions. When you submit the contact form, your
            information is transmitted through EmailJS to our email. EmailJS
            processes this data in accordance with their own privacy policy. No
            other third-party services collect personal data through our
            website.
          </p>

          <h2>4. Cookies</h2>
          <p>
            This website may use essential cookies necessary for the website to
            function properly. We do not use tracking cookies, advertising
            cookies, or third-party analytics cookies.
          </p>

          <h2>5. Data Security</h2>
          <p>
            We take reasonable measures to protect the information you provide
            to us. However, no method of transmission over the internet is 100%
            secure, and we cannot guarantee the absolute security of your data.
          </p>

          <h2>6. Data Retention</h2>
          <p>
            We retain contact form submissions only for as long as necessary to
            respond to your inquiry and for reasonable business purposes. You
            may request deletion of your data at any time by contacting us.
          </p>

          <h2>7. Your Rights</h2>
          <p>You have the right to:</p>
          <ul>
            <li>Request access to the personal information we hold about you</li>
            <li>Request correction of inaccurate information</li>
            <li>Request deletion of your personal information</li>
            <li>Withdraw consent for us to contact you</li>
          </ul>
          <p>
            To exercise any of these rights, please contact us at
            contact@haydenbulktechlabs.com.
          </p>

          <h2>8. Children's Privacy</h2>
          <p>
            Our website and services are not directed to individuals under the
            age of 18. We do not knowingly collect personal information from
            children.
          </p>

          <h2>9. Changes to This Policy</h2>
          <p>
            We may update this Privacy Policy from time to time. Changes will
            be posted on this page with an updated effective date. Your
            continued use of the website after changes are posted constitutes
            your acceptance of the updated policy.
          </p>

          <h2>10. Contact Information</h2>
          <p>
            If you have any questions about this Privacy Policy or how we
            handle your data, please contact us at
            contact@haydenbulktechlabs.com.
          </p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPage;
